module.exports = __webpack_public_path__ + "static/img/etc_05.3dd4b00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/etc_05.jpg
// module id = +62Y
// module chunks = 0